import React, { ReactElement } from 'react';
import { Sparkles } from 'lucide-react';
import { TArrayTypes } from '../../Declarations';

export interface IDelimetersData {
  arrayStyle: string;
  delimiter: string;
  onHandleFlatten: () => void;
  onSetDelimiter: (delimeter: string) => void;
  onSetArrayStyle: (style: TArrayTypes) => void;
}

const Delimeters = (props: IDelimetersData): ReactElement => {
  const { arrayStyle, delimiter, onHandleFlatten, onSetArrayStyle, onSetDelimiter } = props;
  return (
    <div className="mb-4 flex flex-wrap gap-3 items-center">
      <label className="text-sm text-slate-700">Delimiter</label>
      <div className="inline-flex rounded-lg border border-slate-300 overflow-hidden text-sm">
        {/* eslint-disable-next-line prettier/prettier */}
        <button onClick={() => onSetDelimiter('.')} className={`px-3 py-1 ${delimiter === '.' ? 'bg-slate-900 text-white' : 'bg-white'}`}>.</button>
        {/* eslint-disable-next-line prettier/prettier */}
        <button onClick={() => onSetDelimiter('_')} className={`px-3 py-1 ${delimiter === '_' ? 'bg-slate-900 text-white' : 'bg-white'}`}>_</button>
        {/* eslint-disable-next-line prettier/prettier */}
        <button onClick={() => onSetDelimiter(':')} className={`px-3 py-1 ${delimiter === ':' ? 'bg-slate-900 text-white' : 'bg-white'}`}>:</button>
        {/* eslint-disable-next-line prettier/prettier */}
        <button onClick={() => onSetDelimiter('/')} className={`px-3 py-1 ${delimiter === '/' ? 'bg-slate-900 text-white' : 'bg-white'}`}>/</button>
      </div>
      <div className="h-5 w-px bg-slate-300" />
      <label className="text-sm text-slate-700">Array style</label>
      <div className="inline-flex rounded-lg border border-slate-300 overflow-hidden text-sm">
        {/* eslint-disable-next-line prettier/prettier */}
        <button onClick={() => onSetArrayStyle('bracket')} className={`px-3 py-1 ${arrayStyle === 'bracket' ? 'bg-slate-900 text-white' : 'bg-white'}`}>[i]</button>
        {/* eslint-disable-next-line prettier/prettier */}
        <button onClick={() => onSetArrayStyle('dotBracket')} className={`px-3 py-1 ${arrayStyle === 'dotBracket' ? 'bg-slate-900 text-white' : 'bg-white'}`}>.[i]</button>
        {/* eslint-disable-next-line prettier/prettier */}
        <button onClick={() => onSetArrayStyle('dot')} className={`px-3 py-1 ${arrayStyle === 'dot' ? 'bg-slate-900 text-white' : 'bg-white'}`}>.i</button>
      </div>
      <button
        onClick={onHandleFlatten}
        className="ml-auto inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-orange-500 to-amber-400 px-4 py-2 text-white shadow hover:brightness-95">
        <Sparkles className="h-4 w-4" /> Flatten JSON
      </button>
    </div>
  );
};

export default Delimeters;
